import { ReactNode } from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'

import useStyles from './styles'

interface ISectionWrapperProps {
  children: ReactNode
  title?: string | ReactNode
}

const SectionWrapper = ({ children, title }: ISectionWrapperProps) => {
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))
  const classes = useStyles()

  return (
    <Box className={classes.sectionWrapper}>
      {title && isLaptop && <Typography className={classes.sectionTitle}>{title}</Typography>}
      {children}
    </Box>
  )
}

export { SectionWrapper }
